import { Button, ButtonProps } from "antd"

import variables from "@/_styles/variables.module.scss"

interface CustomButtonProps extends ButtonProps {
    themecolor?: "blue" | "lightBlue" | "orange" | "green" | "gray";
}

export const ColorifiedButton = (props: CustomButtonProps) => {

    let themeColor: string
    let styles: React.CSSProperties = {}

    switch(props.themecolor){
        case "green":
            themeColor = variables.btnGreenColor
            break
        case "orange":
            themeColor = variables.btnOrangeColor
            break
        case "gray":
            themeColor = variables.btnGrayColor
            break
        case "lightBlue":
            themeColor = variables.basecolorlight
            break
        case "blue":
        default:
            themeColor = variables.secondBasecolor
            break
    }

    styles = props.variant == "outlined" ? { color: themeColor, borderColor: themeColor } : { backgroundColor: themeColor }

    const combinedStyles = { ...styles, ...props.style  }
    return (
        <>
            <Button
                {...props}
                style={ combinedStyles }
            >
                {props.children}
            </Button>
        </>
    )
}